import React from 'react';
import { IcoProps } from './IconProps';

export const IcoPlus: React.FC<IcoProps> = ({ size = 16 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
                <g fillRule="nonzero" fill="none">
                    <circle fill="#F1F1F1" cx="7.947" cy="7.947" r="6.667" />
                    <path
                        d="M11.28 7.28h-2a.667.667 0 0 1-.667-.667v-2a.667.667 0 0 0-1.333 0v2a.667.667 0 0 1-.667.667h-2a.667.667 0 0 0 0 1.333h2c.368 0 .667.299.667.667v2a.667.667 0 0 0 1.333 0v-2c0-.368.299-.667.667-.667h2a.667.667 0 0 0 0-1.333z"
                        fill="#00B5F4"
                    />
                </g>
            </svg>
        </div>
    );
};
